import React from "react";
import _ from 'underscore';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Currency from "../common/Currency";
import config from "../../config";

const OfferCodeThankYouModal = ({mobile_small,  dismissModal, redirect_on_dismiss}) => {

    const current_time = Date.now();
    const new_date = new Date(current_time + 12096e5);
    const new_date_day = new_date.getDate();
    const new_date_month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][new_date.getMonth()];
    const new_date_year = new_date.getFullYear();
    const is_valid_phone = sessionStorage.getItem('is_valid_phone') || false;
    const wholesale_auth = sessionStorage.getItem("wholesale_auth") || false;
    const rbnew_tier_discounts = {
        "tier_code": "RBNEW",
        "tiers": [
            {
                "min_amount": 1500,
                "code": "RBNEW50",
                "amount_discounted": 50
            },
            {
                "min_amount": 3000,
                "code": "RBNEW100",
                "amount_discounted": 100
            },
            {
                "min_amount": 5000,
                "code": "RBNEW200",
                "amount_discounted": 200
            }
        ]
    };

    return (
        <Modal
            show={true}
            size="lg"
            centered
            onHide={dismissModal}
            className="offer-coupon-thank-you-modal rbg-popup-generic"
            container={document.getElementById('react-header')}
            backdropClassName="dark-overlay overlay-third-modal"
        >
            <Modal.Header className="rbg-popup-generic__header">
                {redirect_on_dismiss ?
                <Button
                    className="rbg-popup-generic__close-icon offer-coupon-thank-you-modal__close-icon"
                    href={`${config.host_rebag_shop}/collections/new-arrivals`}
                    variant="clean"
                    aria-label="Close"
                >
                    <span className="icon-close" />
                </Button>
                :
                <Button
                    className="rbg-popup-generic__close-icon offer-coupon-thank-you-modal__close-icon"
                    onClick={dismissModal}
                    variant="clean"
                    aria-label="Close"
                >
                    <span className="icon-close" />
                </Button>
                }
            </Modal.Header>
            <Modal.Body className="rbg-popup-generic__body">
                <Row className="justify-content-md-center">
                    <Col className="offer-coupon-thank-you-modal__left">
                        <div className="offer-coupon-thank-you-modal__success-title">Thanks for Signing Up!</div>
                        {is_valid_phone &&
                        <div className="offer-coupon-thank-you-modal__success-intro-text-sms">
                            Check your texts. Reply <span className="offer-coupon-thank-you-modal__success-intro-text-sms--bold">"Y"</span> to confirm your subscription.
                        </div>
                        }
                        <div className="offer-coupon-thank-you-modal__success-intro-text">
                            Use code <span  className="offer-coupon-thank-you-modal__success-intro-text--bold">{config.offer_coupon}</span> at<br/> checkout to receive:
                        </div>
                        {rbnew_tier_discounts &&
                        <div className="offer-coupon-thank-you-modal__tier-text-container">
                            {_.map(rbnew_tier_discounts.tiers, (tier) => {
                                return (
                                    <div className="offer-coupon-thank-you-modal__tier-text" key={tier.code}>
                                        <Currency value={tier.amount_discounted} className="offer-coupon-thank-you-modal__tier-text--bold"/> off <Currency value={tier.min_amount}/>+
                                    </div>
                                )
                            })}
                        </div>
                        }
                        <div className="offer-coupon__cta-container">
                            {wholesale_auth ?
                                <Button
                                    href={`${config.host_rebag}/wholesale-partner/`}
                                    className="rbg-btn-black offer-coupon-thank-you-modal__cta"
                                    variant="clean"
                                >
                                    Join our Wholesale Program
                                </Button>
                            :
                                <Button
                                    href={`${config.host_rebag_shop}/collections/new-arrivals`}
                                    className="rbg-btn-black offer-coupon-thank-you-modal__cta"
                                    variant="clean"
                                >
                                    Shop Now
                                </Button>
                            }
                        </div>
                        <div className="offer-coupon-thank-you-modal__success-bottom-text">
                            Offer valid until {`${new_date_month} ${new_date_day}, ${new_date_year}`}. One time use<br /> only and cannot be combined with other offers.
                        </div>
                    </Col>
                    {!mobile_small &&
                    <Col
                        className="offer-coupon-thank-you-modal__right"
                        style={{"backgroundImage": `url(${config.MEDIA_URL}/img/coupon_thank_you_2.jpg)`}}
                    />
                    }
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default OfferCodeThankYouModal;